import _ from "lodash";

export const SidementContent = [
    {
        label: 'Dashboard',
        icon: 'bx bxs-dashboard',
        path: '/dashboard'
    },
    {
        label: 'Organization',
        icon: 'bx bx-user',
        path: '/orgs/list',
        adminOnly: true, // only factory/org admins manage organizations
    },
    {
        label: 'Daily Monitoring',
        icon: 'bx bx-calendar-alt',
        key: 'daily',
        list: [
            {
                label: 'Onsite Inspection',
                key: 'Daily_onSiteInspection',
                path: '/daily-monitoring'
            },
            {
                label: 'Document Review',
                key: 'Daily_Document_Review',
                path: '/daily-document-review'
            },
            {
                label: 'Work Report',
                key: 'Daily_work_report',
                path: '/daily-work-report'
            }
        ]
    },
    {
        label: 'Monthly Monitoring',
        icon: 'bx bx-calendar-event',
        key: 'monthly',
        list: [
            {
                label: 'Onsite Inspection',
                dynamic: 'healthSafetyName',
                key: 'Monthly_onSiteInspection',
                path: '/Health-Safety'
            },
            {
                label: 'Document Review',
                key: 'Monthly_Document_Review',
                dynamic: 'statutoryName',
                path: '/statutory-report'
            },
            {
                label: 'Work Report',
                key: 'Monthly_work_report',
                path: `/monthly-monitoring`
            },
           
        ]
    },
    {
        // Visible to every factory user (no key / adminOnly gate).
        label: 'Tasks Assigned',
        icon: 'bx bx-task',
        path: '/tasks-assigned'
    },
    // {
    //     label: 'Performance Review',
    //     key: 'Performance_Review',
    //     path: '/monthly-monitoring/performanceReview',
    //     icon: 'bx bx-line-chart'
    // },
    {
        label: 'Performance Score',
        key: 'Performance_Review',
        path: '/performance-score',
        icon: 'bx bxs-pie-chart-alt-2'
    }
]

export const pagesPermissions = [
    { label: "Daily - Onsite Inspection", value: 'Daily_onSiteInspection' },
    { label: "Daily - Document Review", value: 'Daily_Document_Review' },
    { label: "Daily - Work report", value: 'Daily_work_report' },
    { label: "Monthly - Onsite Inspection", value: 'Monthly_onSiteInspection' },
    { label: "Monthly - Work report", value: 'Monthly_work_report' },
    { label: "Monthly - Document Review", value: 'Monthly_Document_Review' },
    { label: "Performance Review", value: 'Performance_Review' }
]

// Maps a Report-Scoring/Validation report key to the sidebar menu key, so a
// "View & Validate" user also sees the tabs for reports they can validate.
export const REPORT_KEY_TO_MENU: { [k: string]: string } = {
    dailymonitoring: 'Daily_onSiteInspection',
    dailydocument: 'Daily_Document_Review',
    dailywork: 'Daily_work_report',
    monthlyonsite: 'Monthly_onSiteInspection',
    monthlydocument: 'Monthly_Document_Review',
    monthlywork: 'Monthly_work_report',
}

// `extraKeys` are additional menu keys a user should see beyond their granted
// report permissions (e.g. reports a validator is configured to validate).
export const sidementfilter = (permissions: string[], extraKeys: string[] = []) => {
    // Admins see the full menu.
    if (permissions && permissions.includes('ADMIN')) {
        return SidementContent;
    }

    // Everyone else is filtered by their granted permissions. Treat a missing
    // permission list (factory not loaded yet / none selected) as "no extra
    // permissions" so restricted tabs never flash before data arrives — the
    // previous code returned the FULL menu in this case.
    const perms = permissions || [];
    // Only factory EDIT ("can enter and edit all reports") sees every report tab.
    // VALIDATE users see only the reports they hold or can validate (via extraKeys).
    const allReports = perms.includes('EDIT');
    const allowed = new Set([...perms, ...(extraKeys || [])]);
    const _localFilter: any[] = [];

    _.each(SidementContent, (content: any) => {
        if (content.list && content.list.length > 0) {
            // Submenu group: keep the sub-items the user is permitted to see
            // (all of them for EDIT).
            const _local = allReports
                ? content.list
                : _.filter(content.list, (value: any) => allowed.has(value.key));
            if (_local.length > 0) {
                _localFilter.push({ ...content, list: _local });
            }
        } else if (content.key) {
            // Permission-gated top-level item (e.g. Performance Score).
            if (allowed.has(content.key)) {
                _localFilter.push(content);
            }
        } else if (content.adminOnly) {
            // Admin-only item (e.g. Organization): hidden for normal users.
            // Admins never reach here — they get the full menu via the early
            // return above.
        } else {
            // Ungated base navigation item (e.g. Dashboard).
            _localFilter.push(content);
        }
    });

    return _localFilter;
}